import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import { format } from 'date-fns';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import CustomCheckbox from 'src/components/CustomComponent/CustomCheckbox';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingSpinner from 'src/components/CustomComponent/LoadingSpinner';
import './BCPOverviewFloor.less';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class BCPOverviewFloor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data ?? [],
      dataTableFloor: this.props.dataTableFloor ?? [],
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: this.props.isLoading ?? false,

      selectedFloor: {},
      textSearchBranchName: '',
      textSearchFloorName: '',
      searchText: '',
      showBranch: true,
      showFloor: true,
    };

    // Data get from API
    this.dataFloor = [];

    this.dataTableFloorRef = React.createRef();
    this.filters = {
      branch_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      floor_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    };

    this.dataColumns = [
      {
        field: 'branch_name',
        header: COMMON_TEXT.BRANCH,
        align: 'left',
        headerClassName: 'text-left',
        bodyClassName: 'text-left',
        bodyStyle: {
          color: '#FFF',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
      {
        field: 'floor_name',
        header: COMMON_TEXT.FLOOR,
        align: 'left',
        headerClassName: 'text-left',
        bodyClassName: 'text-left',
        bodyStyle: {
          color: '#FFF',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
      {
        field: 'pc_count',
        header: 'PC',
        align: 'left',
        headerClassName: 'text-left',
        bodyClassName: 'text-left',
        bodyStyle: {
          color: '#FFF',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
      {
        field: 'phone_count',
        header: 'スマホ',
        align: 'left',
        headerClassName: 'text-left',
        bodyClassName: 'text-left',
        bodyStyle: {
          color: '#FFF',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
      {
        field: 'timestamp',
        header: '更新日時',
        align: 'left',
        headerClassName: 'text-left',
        bodyClassName: 'text-left',
        bodyStyle: {
          color: '#A2A8BB',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
      {
        field: 'button',
        header: '',
        align: 'right',
        headerClassName: 'text-right',
        bodyClassName: 'text-right',
        bodyStyle: {
          color: '#A2A8BB',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '12px',
          padding: '8px 0px',
          background: '#252F55',
          transition: 'background 0.2s',
          fontWeight: 700,
          borderBottom: '1px solid #505680',
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        },
      },
    ];
  }

  componentDidMount() {
    const { tenant } = this.state;
    const { data, dataTableFloor, isLoading } = this.props;

    this.setState({
      tenant,
      data,
      dataTableFloor,
      isLoading,
    });
    this.dataFloor = dataTableFloor;
  }

  componentDidUpdate(prevProps) {
    const { data, dataTableFloor, isLoading } = this.props;
    const {
      data: prevData,
      dataTableFloor: prevDataTable,
      isLoading: prevIsLoading,
    } = prevProps;

    const isDataChanged = data !== prevData;
    const isDataTableChanged = dataTableFloor !== prevDataTable;
    const isLoadingChanged = isLoading !== prevIsLoading;

    if (isDataChanged || isDataTableChanged || isLoadingChanged) {
      this.setState({
        data,
        dataTableFloor,
        isLoading,
      });
      this.dataFloor = dataTableFloor;
    }
  }

  renderMessageError = () => {
    const { tenant } = this.state;
    if (!tenant) {
      return (
        <Message
          severity="error"
          text={COMMON_TEXT.TENANT_NOT_SELECTED_PLEASE_SELECT}
        />
      );
    }
  };

  rowClass = data => {
    const { selectedFloor } = this.state;
    return {
      'is-selected': data.floor_id === selectedFloor.floor_id,
    };
  };

  updateSelectedFloor = ({ floor }) => {
    this.setState({
      selectedFloor: floor,
    });
    this.props.updateSelectedFloor({
      floor,
    });
  };

  handleSearchChange = (e) => {
    const searchText = e.target.value;
    this.setState({ searchText });
    this.filterData(searchText, this.state.showBranch, this.state.showFloor);
  };

  handleFilterChange = (filterType, checked) => {
    const newState = { [filterType]: checked };
    this.setState(newState, () => {
      this.filterData(this.state.searchText, this.state.showBranch, this.state.showFloor);
    });
  };

  filterData = (searchText, showBranch, showFloor) => {
    let filteredData = [...this.dataFloor];

    // Apply search filter
    if (searchText) {
      filteredData = filteredData.filter(item => {
        const branchMatch = showBranch && item.branch_name && item.branch_name.toLowerCase().includes(searchText.toLowerCase());
        const floorMatch = showFloor && item.floor_name && item.floor_name.toLowerCase().includes(searchText.toLowerCase());
        // If both are false, do not filter by either (return all data)
        if (!showBranch && !showFloor) return true;
        // If both are true, match either
        if (showBranch && showFloor) return branchMatch || floorMatch;
        // If only one is true, match that one
        return branchMatch || floorMatch;
      });
    }

    this.setState({ dataTableFloor: filteredData });
  };

  renderDataTable({ tableData }) {
    const { isLoading } = this.state;

    return (
      <>
        <DataTable
          ref={this.dataTableFloorRef}
          className="outlook-data-table"
          value={tableData}
          tableStyle={{ width: '100%' }}
          size="small"
          scrollHeight="calc(100vh - 350px)"
          showGridlines
          loading={isLoading}
          rowClassName={this.rowClass}
          selectionMode="single"
          onSelectionChange={e => this.updateSelectedFloor({ floor: e.value })}
          emptyMessage={() => {
            return (
              <div className="flex justify-content-center align-items-center">
                <div className="no-data-container">
                  {COMMON_TEXT.NO_DATA}
                </div>
              </div>
            );
          }}
        >
          {this.dataColumns.map(col => {
            return (
              <Column
                dataType={col.dataType ?? 'string'}
                key={col.field}
                field={col.field}
                header={col.header}
                align={col.align}
                alignHeader={col.align}
                headerClassName={col.headerClassName}
                bodyClassName={col.bodyClassName}
                headerStyle={{
                  color: '#A2A8BB',
                  fontFamily: 'DM Sans, sans-serif',
                  fontSize: '12px',
                  fontWeight: 700,
                  padding: '8px 0px',
                  letterSpacing: '0.02em',
                  background: '#252F55',
                  textAlign: 'left',
                  borderBottom: '1px solid #505680',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                }}
                bodyStyle={col.bodyStyle}
                body={dataItem => {
                  switch (col.field) {
                    case 'timestamp':
                      return dataItem[col.field] != null
                        ? format(
                          new Date(dataItem[col.field]),
                          'MM月dd日 HH:mm'
                        )
                        : null;
                    case 'button':
                      const isSelected = this.state.selectedFloor && this.state.selectedFloor.floor_id === dataItem.floor_id;
                      return (
                        <button
                          className={`row-arrow-btn${isSelected ? ' selected' : ''}`}
                          onClick={() => this.updateSelectedFloor({ floor: dataItem })}
                          aria-label="詳細"
                          type="button"
                        >
                          <i
                            className="pi pi-angle-right"
                            style={{
                              fontSize: '12px',
                              color: isSelected ? '#FFF' : '#252F55',
                              transition: 'color 0.2s',
                            }}
                          />
                        </button>
                      );
                    default:
                      return dataItem[col.field];
                  }
                }}
              />
            );
          })}
        </DataTable>
      </>
    );
  }

  render() {
    const { isLoading, dataTableFloor, searchText, showBranch, showFloor } = this.state;

    return (
      <div className="bcp-overview-floor overview-floor-container">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="search-section">
              <div className="search-bar">
                <img
                  src="/assets/img/search-icon.svg"
                  alt="Search"
                  className="search-icon"
                />
                <InputText
                  value={searchText}
                  onChange={this.handleSearchChange}
                  placeholder="検索"
                  className="search-input"
                />
              </div>
              <div className="filter-checkboxes">
                <CustomCheckbox
                  checked={showBranch}
                  onChange={(e) => this.handleFilterChange('showBranch', e.checked)}
                  label="拠点"
                />
                <CustomCheckbox
                  checked={showFloor}
                  onChange={(e) => this.handleFilterChange('showFloor', e.checked)}
                  label="フロア"
                />
              </div>
            </div>
            <div className="table-container">
              {this.renderDataTable({
                tableData: dataTableFloor,
              })}
            </div>
          </>
        )}
      </div>
    );
  }
}

BCPOverviewFloor.propTypes = {
  dataTableFloor: PropTypes.array,

  updateSelectedFloor: PropTypes.func,
};

export default BCPOverviewFloor;
